import { Component, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators, Form, FormGroup, FormControl, FormArray } from '@angular/forms';
import { Pattern } from '../../../../shared/validators/pattern';
import { ProductService } from '../../../../shared/services/product/product.service';
// import { forEach } from '@angular/router/src/utils/collection';
// import { ChartDataset  } from 'ng2-charts';
import { LoaderService } from '../../../../core/services/loader/loader.service';
import { NotificationService } from '../../../../core/services/notification/notification.service';
import { environment } from '../../../../../environments/environment';
import { IClientAuthorizeCallbackData, ICreateOrderRequest, IPayPalConfig } from 'ngx-paypal';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-inventory-details',
  templateUrl: './inventory-details.component.html',
  styleUrls: ['./inventory-details.component.css']
})
export class InventoryDetailsComponent implements OnInit {
  productID: any;
  addInventoryDetails: FormGroup;
  Title: string;
  Price: any;
  myForm: FormGroup;
  Categories: any[];
  SKU: any;
  imageList: string[] = [];
  TotalQuantityOnWay: number;
  designId: number;
  maxPrice: number;
  minPrice: number;
  total: number = 0;
  totalCosttoCharge: any;
  isBulkOrderProduct: boolean = false;
  public payPalConfig?: IPayPalConfig;
  BulkDiscount: any[];
  totalQuantity: number = 0;
  decPercentage: any = 0;
  discountedPrice: number;
  flag: boolean=false;
  data: FormGroup;

  constructor(private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder,
    private route: Router, private changeDetectorRefs: ChangeDetectorRef,
    private productServices: ProductService, private loader: LoaderService
    , private notificationService: NotificationService,
    private cp: CurrencyPipe,
    private zone: NgZone) {
    this.addInventoryDetails = this.formBuilder.group({
      Styles: this.formBuilder.array([])
    })
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params =>
      this.productID = params['productid']);
    this.fn_getBulKDiscount();
    this.fn_GetInventoryDetails(this.productID);
  }

  fn_getBulKDiscount() {
    this.productServices.fn_GetBulkOrderDiscount().subscribe((res: any) => {
      if (res.StatusCode == 200) {
        this.BulkDiscount = res.Data.ResponseData;
        this.loader.hide();
      }

    })
  }
  fn_GetInventoryDetails(productId: any) {
    this.productServices.getCustomProductsDetails(productId).subscribe((res: any) => {
      if (res.StatusCode == 200) {
        this.Title = res.Data.ResponseData.Title;
        this.SKU = res.Data.ResponseData.SKU;
        this.Categories = res.Data.ResponseData.Categories;
        this.Price = res.Data.ResponseData.RetailPrice;
        this.designId = res.Data.ResponseData.DesignId;      
        this.isBulkOrderProduct = this.designId > 0 ? true : false;        

        this.fn_setWarehouseVariant(res.Data.ResponseData.WarehouseVariants, this.Price);


      }
    })
  }
  fn_GetImage(imageName: string) {
    if (imageName.indexOf('https://stores.inksoft.com') !== -1) {
      return imageName;
    } else {
      return  environment.warehouseProductCustomImageFolder + imageName;
    }

  }

  fn_setWarehouseVariant(WarehouseVariants: any, DefualtPrice: any) {
    let totalQuantityOnWay = 0;
    let Styles = this.addInventoryDetails.get('Styles') as FormArray;
    WarehouseVariants.forEach((style) => {
      var sizes = [];
      style.Size.forEach((i) => {

        let defualtPrice = i.Price == 0 ? DefualtPrice : i.Price;
        totalQuantityOnWay = totalQuantityOnWay + i.ProposedQuantity;

        sizes.push(
          this.formBuilder.group({
            SizeId: new FormControl({ value: i.SizeId, disabled: false }),
            SizeName: new FormControl({ value: i.SizeName, disabled: false }),
            Quantity: new FormControl({ value: 0, disabled: false }),
            UnitPrice: new FormControl({ value: defualtPrice, disabled: false }),
            StyleId: new FormControl({ value: i.StyleId, disabled: false }),
            StockOnHandQuantity: new FormControl({ value: i.StockOnHandQuantity, disabled: true }),
            CurrentPrice: new FormControl({ value: i.Price, disabled: true }),
            ProposedQuantity: new FormControl({ value: i.ProposedQuantity, disabled: true }),
          })
        );
      })
      let lowest = style.Size.sort((a, b) => a.Price - b.Price);
      this.maxPrice = lowest[lowest.length -1].Price
      this.minPrice = lowest[0].Price
      // this.max = [lowest.length - 1].Price
      Styles.push(
        this.formBuilder.group({
          StyleId: new FormControl(style.StyleId),
          ColorName: new FormControl(style.ColorName),
          HexCode: new FormControl(style.HexCode),
          Sizes: this.formBuilder.array(sizes)
        })
      )
      style.WarehouseProductImages.forEach((img) => {
        if (this.imageList.length <= 6)
          this.imageList.push(img.ImageName);
      });
    });

    this.TotalQuantityOnWay = totalQuantityOnWay;
  }

  /** Function to display product color(s) in color selector */
  displayColor(obj: any) {
    return {
      'background': obj
    };
  }



  AddInventoryDetails(form: FormGroup) {
    this.loader.show();
    let addInventoryDetails = form.value;
    addInventoryDetails = {
      ...addInventoryDetails,
      ProductId: this.productID,
      UserId: localStorage.getItem('userId'),
      
    };
    this.productServices.saveInventoryDetails(addInventoryDetails).subscribe((res: any) => {
      if (res.StatusCode == 200) {
        this.notificationService.success("Inventory successfully saved", "Success");

        this.route.navigate(['productlisting'], { relativeTo: this.activatedRoute.parent });
        this.loader.hide();
      }
    });
  }
  fn_viewProductdetais(productId: number) {
    this.route.navigate(['viewcustomdetail', productId], { relativeTo: this.activatedRoute.parent });
  }
  fn_PaypalInitConfig(): void {
    this.payPalConfig = {
      currency: 'USD',
      clientId: environment.paypalPublicKey,
      createOrderOnClient: (data): ICreateOrderRequest => {
        return {
          intent: 'CAPTURE',
          application_context: {
            brand_name: "MerchLoop",
            shipping_preference: "NO_SHIPPING"
          },
          purchase_units: [{
            amount: {
              currency_code: 'USD',
              value: (this.cp.transform(this.totalCosttoCharge, '', '', '1.2-2')).toString(),
              breakdown: {
                item_total: {
                  currency_code: 'USD',
                  value: (this.cp.transform(this.totalCosttoCharge, '', '', '1.2-2')).toString()
                }
              }
            },
            items: [{
              name: "WP_" + this.productID,
              quantity: '1',
              category: 'PHYSICAL_GOODS',
              unit_amount: {
                currency_code: 'USD',
                value: (this.cp.transform(this.totalCosttoCharge, '', '', '1.2-2')).toString()
              },
            }]
          }]
        };
      },
      advanced: {
        commit: 'true'
      },
      style: {
        label: 'pay',
        layout: 'horizontal'
      },
      
      onApprove: (data, actions) => {
      },
      onClientAuthorization: (info: IClientAuthorizeCallbackData) => {
        this.zone.run(() => {
          let addInventoryDetails = this.data.value;
          addInventoryDetails = {
            ...addInventoryDetails,
            ProductId: this.productID,
            UserId: localStorage.getItem('userId'),
            PaymentId: info.id,
            PayPalPayerId: info.payer.payer_id,
            TotalPrice: Number(this.totalCosttoCharge),
          };       
          this.updateShipmentDetails(addInventoryDetails);
        });
      },
      onCancel: (data, actions) => {
        this.notificationService.info('Your transaction has been cancelled', 'Payment');
      },
      onError: err => {
        // this.router.navigate([this.parentRouteParam + '/paymentfailed']);
        // window.location.reload();
      },
      onClick: (data, actions) => {
      },
    };
  }

  fn_calculateBulkPrice(qnty: any, price: number) {
    this.totalQuantity = 0;
    this.total = 0
    this.calculateTotal();
    this.changeDetectorRefs.detectChanges();


  }
  public calculateTotal() {

  let Styles = this.addInventoryDetails.get('Styles') as FormArray;
  var styles = Styles.value;
  for (var i = 0; i < styles.length; i++) {
    var sizes = styles[i].Sizes;
    for (var j = 0; j < sizes.length; j++) {
      this.totalQuantity += sizes[j].Quantity;
      if (sizes[j].Quantity > 0) {
        this.total += sizes[j].Quantity * sizes[j].UnitPrice;
      }
    }
    }
    this.decPercentage = this.BulkDiscount.filter(x => x.MinQty <= this.totalQuantity && x.MaxQty >= this.totalQuantity).map(x => x.DiscountPercentage)[0];
    this.discountedPrice = ((this.total * this.decPercentage) / 100);
    this.totalCosttoCharge = (this.total - this.discountedPrice).toFixed(2)

  }

  payNow(form: FormGroup) {
    if (this.totalQuantity <= 10) {
      this.notificationService.error('Please enter  minimum 10 quantity for bulk order', 'Validation error');
    } else {
      this.fn_PaypalInitConfig();
      this.data=form
      this.flag = true;
    }
    
  }

  updateShipmentDetails(form :any) {
    this.loader.show();
    this.productServices.saveInventoryDetails(form).subscribe((res: any) => {
      if (res.StatusCode == 200) {
        this.notificationService.success("Inventory successfully saved", "Success");
        this.route.navigate(['productlisting'], { relativeTo: this.activatedRoute.parent });
        this.loader.hide();
      }
    });
  }

}
